interface Props {
  children: JSX.Element[] | JSX.Element;
}
function FullSectionText(props: Props): JSX.Element {
  return (
    <section className="content-container tf-no-result tf-section">
      <div
        className="themesflat-container d-flex flex-column justify-content-center"
        style={{ minHeight: 'min(40vh, 800px)', marginBottom: '80px' }}
      >
        <div className="tf-title-heading ct style-2 fs-30">
          {props.children}
        </div>
      </div>
    </section>
  );
}

export default FullSectionText;
